import type {
  WorkplaceRequestTypeField,
  WorkplaceRequestTypeFieldType
} from "@gettactic/api";

const SELECT_FIELD_TYPES = new Set<WorkplaceRequestTypeFieldType>([
  "single_select",
  "multi_select"
]);

/**
 * Whether a select field should render as a large image picker rather than a
 * dropdown: it does once *every* option carries an image, since at that point
 * the choice is visual. A partial set of images stays a dropdown with inline
 * thumbnails.
 *
 * Shared by the renderer and the row packer so the two cannot disagree — an
 * image picker needs a full row, unlike the compact dropdown it replaces.
 */
export const isImageOptionField = (
  field: WorkplaceRequestTypeField
): boolean => {
  if (!SELECT_FIELD_TYPES.has(field.field_type)) return false;
  const options = field.options ?? [];
  return options.length > 0 && options.every((o) => Boolean(o.image_url));
};
